import type { User } from '@/@types/user'
import { css } from '@emotion/react'
import {
	type BeautifulMentionComponentProps,
	type BeautifulMentionsTheme,
	useBeautifulMentions,
} from 'lexical-beautiful-mentions'
import { forwardRef } from 'react'
import MentionUser from '../MentionUser'

export const userMentionsTheme: BeautifulMentionsTheme = {
	'@': 'mention-user',
	'@Focused': 'focused',
}
export interface LexicalMentionNodeProps extends Omit<BeautifulMentionComponentProps, 'data'> {
	data: {
		data: User
		id: string
	}
}

export default forwardRef<HTMLDivElement, LexicalMentionNodeProps>(function LexicalMentionNode(
	{ trigger, value, data: { data }, children, ...props },
	ref
) {
	const { removeMentions } = useBeautifulMentions()

	return (
		<MentionUser
			ref={ref}
			css={css`
				transform: translateY(1.5px);
			`}
			onClick={() =>
				void removeMentions({
					trigger: '@',
					value,
				})
			}
			data={data}
		/>
	)
})
